module.exports = __webpack_public_path__ + "static/img/bes_logo.2f3d7cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bes_logo.png
// module id = tZdN
// module chunks = 0